import React from "react"

import HomeUI from "../../ui/homeUI/_index";

const MediumManager = () => {
  return (
    <HomeUI />
  )
}

export default MediumManager